import React from "react";

import { Route, Redirect, useLocation } from "react-router-dom";
import MainMenu from "MainMenu/MainMenu";

const AuthenticatedRoute = ({ component: C, props: childProps, ...rest }) => {
  const { pathname, search } = useLocation();
  return (
    <Route
      {...rest}
      render={(props) =>
        childProps.isAuthenticated ? (
          <MainMenu>
            <C {...props} {...childProps} />
          </MainMenu>
        ) : (
          <Redirect to={`/login?redirect=${pathname}${search}`} />
        )
      }
    />
  );
};

export default AuthenticatedRoute;
